export default {"src":"/_next/static/media/exclamation-bubble-red.db40214d.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};